import type { FaireProductEntity } from "../../entity_types/product";

export const p_thdy9efqx6: FaireProductEntity = {
  token: "p_thdy9efqx6",
  type: "product",
  name: "Cape Malt Non-alcoholic Whiskey Alternative",
  brandToken: "b_g593ctghc8",
  brandName: "Abstinence Spirits",
  imageUrl:
    "https://cdn.faire.com/fastly/386c353ab45e092b49d3f35d112eaf5a7df2cb7199ae7fbf764da7d37ddf3b46.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7cf608f70b565d96c8cbdc4fc7281db24e01b527d87b3e9556e89fe97c871820.jpeg",
    "https://cdn.faire.com/fastly/1bf21ebd27fa8b05d5a342a62aa0e70eebde5c2ee15e32fb830909565d58f825.png",
  ],
  priceDollars: 35,
  description:
    "\nAbstinence Cape Malt is a masterful blend of American bourbon notes and Scottish whiskey influences, offering a bold non-alcoholic spirit experience. Crafted with peated, smoked, and dark toasted malt, this spirit is enriched by a blend of spice botanicals and South African Rooibos. The result is a smooth, richly textured whiskey alternative, featuring mellow vanilla, caramel, and toffee on the nose, with a subtle hint of peated smoke and American oak. A hint of Rooibos adds a unique South African twist, giving it an extra layer of complexity.\n",
  tags: [],
  msrpDollars: 50,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:57.338Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
